export default __webpack_public_path__ + "static/media/ic-distance-large.194004b8.svg";